import client from "@/api";
import store from "@/store";
import {
  _rotaMidiaSummary,
  _rotaMidiaTotals,
  _rotaMidiaKpis,
  _rotaMidia,
} from "@/api/_caminhosApi";
import { arrayToFilterString } from "@/utils/array";



export function fetchMidiaSummary(from, to, filters) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("midia/RESET_SUMMARY", null);
  client
    .get(_rotaMidiaSummary(), {
      params: {
        from,
        to,
        filters: arrayToFilterString(filters),
      },
    })
    .then((resp) => {
      store.commit("midia/SET_SUMMARY", resp.data);
    })
    .catch((erro) => {
      console.error(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}


export function fetchMidiaTotals(from, to, filters) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("midia/RESET_TOTALS", null);
  client
    .get(_rotaMidiaTotals(), {
      params: {
        from,
        to,
        filters: arrayToFilterString(filters),
      },
    })
    .then((resp) => {
      store.commit("midia/SET_TOTALS", resp.data);
    })
    .catch((erro) => {
      console.error(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}


export function fetchMidiaKpis(from, to, filters) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("midia/RESET_KPIS", null);
  client
    .get(_rotaMidiaKpis(), {
      params: {
        from,
        to,
        filters: arrayToFilterString(filters),
      },
    })
    .then((resp) => {
      store.commit("midia/SET_KPIS", resp.data);
    })
    .catch((erro) => {
      console.error(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function getMidiaCampaigns() {
  store.commit("interacoes/SET_LOADING", true);
  client
    .get(`${_rotaMidia()}/campaigns`)
    .then(resp => {
      console.log('getMidiaCampaigns resp', resp)
      store.commit("midia/SET_CAMPAIGNS", resp.data);
      return resp.data;
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}